import { createApp } from 'vue/dist/vue.esm-bundler'
import ToastPlugin from 'vue-toast-notification'
import { LoadingPlugin } from 'vue-loading-overlay'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import 'vue-loading-overlay/dist/css/index.css'
import './assets/tailwind.css'
import './assets/toast.css'

const app = createApp(App)
const pinia = createPinia()

// Add persistence plugin to pinia
pinia.use(piniaPluginPersistedstate)

app.use(ToastPlugin)
app.use(LoadingPlugin)
app.use(pinia)
app.use(router)

app.mount('#app')
